<template>
  <!-- eslint-disable  -->
  <component is="li" v-on="$listeners">
    <b-avatar class="cs-avatar-role">
      <feather-icon :icon="data.icon ? data.icon : 'AtSignIcon'" />
    </b-avatar>
    <div class="chat-info flex-grow-1">
      <h5 class="mb-0">
        {{ data.name }}
      </h5>
      <!-- <p class="card-text text-truncate">
                @{{ data.code }}
            </p> -->
    </div>
    <div class="chat-meta text-nowrap">
      <b-dropdown variant="link" no-caret dropleft>
        <template #button-content>
          <feather-icon
            icon="MoreVerticalIcon"
            size="16"
            class="align-left text-body"
          />
        </template>

        <b-dropdown-item @click="showEdit(data)">
          <feather-icon icon="EditIcon" />
          <span class="align-left ml-50">Sửa</span>
        </b-dropdown-item>

        <b-dropdown-item @click="showConfirmDeleteModule(data)">
          <feather-icon icon="TrashIcon" />
          <span class="align-left ml-50">Xóa</span>
        </b-dropdown-item>
      </b-dropdown>
    </div>
  </component>
</template>

<script>
/* eslint-disable */
import { BAvatar, BBadge, BDropdown, BDropdownItem } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { RolesDelete as DeleteData } from "@/services/api/DefaultTemplate/RoleService";

export default {
  components: {
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
  },
  props: {
    tag: {
      type: String,
      default: "div",
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isWait: false,
    };
  },
  methods: {
    showEdit(data) {
      this.$emit("show-edit", JSON.parse(JSON.stringify(data)));
    },
    showConfirmDeleteModule(data) {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        this.$bvModal
          .msgBoxConfirm("Are you sure?", {
            cancelVariant: "outline-secondary",
          })
          .then((value) => {
            if (value) {
              this.isWait = true;
              DeleteData(data.id).then((res) => {
                this.isWait = false;
                if (res.isError) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thất bại",
                      icon: "AlertTriangleIcon",
                      variant: "error",
                      text: res.message,
                    },
                  });
                } else {
                  this.$emit("reload-list");
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thành công",
                      icon: "CheckIcon",
                      variant: "success",
                      text: res.message,
                    },
                  });
                }
              });
            }
          });
      }
    },
  },
  setup() {
    return {};
  },
};
</script>

<style></style>
